import React from 'react';

import './GameOver.scss';

const GameOver = () => {
    return (
        <div className="game-over">
            <div className="game-over-content">
                <span className="game-over-title">WELL DONE!</span>
                <p className="game-over-message">
                    I hope you enjoyed this round :)<br></br> Feel free to edit the words and replay the game.<br></br>{' '}
                    For any question or suggestions please contact me on my twitter{' '}
                    <a href="https://twitter.com/mattibarzeev" target="_blank" rel="noopener noreferrer">
                        @mattibarzeev
                    </a>
                </p>
            </div>
        </div>
    );
};

export default GameOver;
